import { useStytchMemberSession } from '@stytch/react/b2b';
import { Redirect } from 'expo-router';
import React from 'react';

import type { ContainerComponent } from '../../common/types/Common';
import { captureMessage } from '../../logger/Logger';
import { setStoredRedirectPath } from '../helpers';

const RedirectIfNotAuthenticated: ContainerComponent = ({ children }) => {
    const { session } = useStytchMemberSession();

    if (!session) {
        // Store the current path for redirect after successful authentication
        const currentPath =
            window.location.pathname +
            window.location.search +
            window.location.hash;
        setStoredRedirectPath(currentPath);

        captureMessage(
            `No session found. Redirecting to /sign-in from ${currentPath}`,
        );
        return <Redirect href="/sign-in" />;
    }

    return <>{children}</>;
};

export default RedirectIfNotAuthenticated;
